export const otherListingProperties = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Serious buyers only",
        img: "/images/newLanding/bb1.svg",
        body: "Tired of putting that in your listing description and still dealing with unqualified leads? Zonado is 100% dedicated to Commercial Real Estate and Sale of Business so you reach to the right buyer group."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "NDAs to keep you safe",
        img: "/images/newLanding/bb2.svg",
        body: "Not ready to disclose confidential information? We understand. Secure your documents and use the in-built NDA to get approval and share information with confidence. "
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Save Time, Sell Better",
        img: "/images/newLanding/bb3.svg",
        body: "Our smart algorithm will automatically match your listing with the right buyer the moment they hit the market. All you have to do is start the conversation."
    }
];

export const otherListingPropertiesTools = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "On and Off-Market Properties ",
        img: "/images/newLanding/realtor5.svg",
        body: "Not ready to share the exact address publicly? No problem."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "No Time Limits",
        img: "/images/newLanding/realtor6.svg",
        body: "We do not limit your listing to a set number of days. Your listing will remain visible on Zonado until you mark it sold or leased. "
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "In-App Messaging and Lead Vetting",
        img: "/images/newLanding/realtor7.svg",
        body: "With in-app messaging and lead vetting, spend your time talking to the right people."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Advanced Lead Tracking & Analytics",
        img: "/images/newLanding/realtor8.svg",
        body: "Easily track how your listing is performing, who is viewing it, and who is attempting to contact you. "
    }
]